import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import helpers from "../utils/helpers";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";

const Dashboard2 = () => {
  const [data, setData] = useState({});
  const { user } = useContext(AuthContext);
  const [headerTab, setHeaderTab] = useState("amount");
  const [headerTab3, setHeaderTab3] = useState("winning");
  const [headerTab1, setHeaderTab1] = useState("matched_events");
  const [headerTab2, setHeaderTab2] = useState("suspect_users");
  const [topData, setTopdata] = useState({});
  const navigate = useNavigate();
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 10,
    fromPeriod: currentDate,
    toPeriod: currentDate,
    filterByDay: "",
  });
  const [obj, setObj] = useState({});
  const [sumData, setSumData] = useState({});
  const [pldata, setPlData] = useState([]);
  const getData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.getDashboard,
      {
        fromPeriod: filter?.fromPeriod,
        toPeriod: filter?.toPeriod,
      },
    );
    if (status === 200) {
      if (response_users.success) {
        setData(response_users?.results);
      }
    }
  };
  const getTopAmount = async () => {
    const { status, data: response_users } = await apiGet(apiPath.riskProfile);
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setTopdata(response_users.results);
        }
      }
    }
  };
  const getPlData = async (type = "search") => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path = apiPath.reportDownlineNew;

    try {
      const { status, data: response_users } = await apiGet(
        path,
        type == "search" ? filter : type,
      );
      if (status === 200) {
        if (response_users.success) {
          setPlData(response_users.results.data);
          setSumData(response_users.results.sumData);
          // console.log(response_users.results.data, "data");
          // setPageCount(response_users.results.totalPages);
          const commission = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.commission);
            return a;
          }, 0);
          const stake = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.realAmount);
            return a;
          }, 0);
          const sportsPL = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.sportData?.amount);
            return a;
          }, 0);
          const casinoPL = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.casinoData?.amount);
            return a;
          }, 0);

          const auraCasinoDataPL = response_users?.results?.data?.reduce(
            (a, v) => {
              a = parseInt(a) + parseInt(v?.auraCasinoData?.amount);
              return a;
            },
            0,
          );
          const iqCasinoDataDataPL = response_users?.results?.data?.reduce(
            (a, v) => {
              a = parseInt(a) + parseInt(v?.iqCasinoData?.amount);
              return a;
            },
            0,
          );
          setObj({
            commission: commission || 0,
            stake: stake || 0,
            totalSportsPL: sportsPL || 0,
            totalCasinoPL: casinoPL || 0,
            totalauraCasinoDataPL: auraCasinoDataPL || 0,
            totaliqCasinoDataDataPL: iqCasinoDataDataPL || 0,
          });
        }
      }
    } catch (err) {
      // toast.error(err.response.data.message);
    }
  };
  useEffect(() => {
    getData();
    getTopAmount();
    getPlData();
  }, []);
  return (
    <div>
      <section className="main-inner-outer py-3" style={{ margin: `15px` }}>
        <Container fluid>
          {" "}
          <div className="row g-3  mb-3 mb-md-4">
            <div className="col-12 col-md-6 col-lg-3">
              <div
                style={{
                  "border-radius": "8px",
                  color: "white",
                  position: "relative",
                  height: "clamp(140px, 20vw, 160px)",
                  display: "flex",
                  "-webkit-flex-direction": "column",
                  "-ms-flex-direction": "column",
                  "flex-direction": "column",
                  "-webkit-box-pack": "space-between",
                  "-webkit-justify-content": "space-between",
                  "-ms-flex-pack": "space-between",
                  "justify-content": "space-between",
                  overflow: "hidden",
                  "background-color": "rgb(76, 29, 36)",
                }}
              >
                <div style={{ padding: "20px" }}>
                  <div
                    style={{
                      "font-family": "Arial, san-serif",
                      "font-size": "clamp(24px, 4vw, 28px)",
                      margin: "8px 0px",
                      "line-height": "1",
                    }}
                  >
                    <span
                      style={{ "font-size": "0.4em", "margin-right": "4px" }}
                    >
                      Total User:
                    </span>
                    {data?.userCount || 0}
                  </div>
                </div>
                <div
                  style={{
                    "font-size": "12px",
                    "font-weight": "600",
                    opacity: "0.8",
                    display: "flex",
                    "-webkit-align-items": "center",
                    "-webkit-box-align": "center",
                    "-ms-flex-align": "center",
                    "align-items": "center",
                    gap: "4px",
                    width: "100%",
                    padding: "10px",
                    background: "rgba(0, 0, 0, 0.15)",
                  }}
                >
                  Users
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={32}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-users"
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    bottom: "50px",
                    right: "15px",
                    opacity: "0.4",
                    width: "64px",
                    height: "64px",
                  }}
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <circle cx={9} cy={7} r={4} />
                </svg>
              </div>
            </div>
            {/* <div className="col-12 col-md-6 col-lg-3">
              <div
                style={{
                  "border-radius": "8px",
                  color: "white",
                  position: "relative",
                  height: "clamp(140px, 20vw, 160px)",
                  display: "flex",
                  "-webkit-flex-direction": "column",
                  "-ms-flex-direction": "column",
                  "flex-direction": "column",
                  "-webkit-box-pack": "space-between",
                  "-webkit-justify-content": "space-between",
                  "-ms-flex-pack": "space-between",
                  "justify-content": "space-between",
                  overflow: "hidden",
                  "background-color": "rgb(139, 92, 246)",
                }}
              >
                <div style={{ padding: "20px" }}>
                  <div
                    style={{
                      "font-family": "Arial, san-serif",
                      "font-size": "clamp(24px, 4vw, 28px)",
                      margin: "8px 0px",
                      "line-height": "1",
                    }}
                  >
                    <span
                      style={{ "font-size": "0.4em", "margin-right": "4px" }}
                    >
                      Total Agent:
                    </span>
                    {data?.agentCount || 0}
                  </div>
                </div>
                <div
                  style={{
                    "font-size": "12px",
                    "font-weight": "600",
                    opacity: "0.8",
                    display: "flex",
                    "-webkit-align-items": "center",
                    "-webkit-box-align": "center",
                    "-ms-flex-align": "center",
                    "align-items": "center",
                    gap: "4px",
                    width: "100%",
                    padding: "10px",
                    background: "rgba(0, 0, 0, 0.15)",
                  }}
                >
                  Agent
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={32}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-circle-user-round"
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    bottom: "50px",
                    right: "15px",
                    opacity: "0.4",
                    width: "64px",
                    height: "64px",
                  }}
                >
                  <path d="M18 20a6 6 0 0 0-12 0" />
                  <circle cx={12} cy={10} r={4} />
                  <circle cx={12} cy={12} r={10} />
                </svg>
              </div>
            </div> */}
            <div className="col-12 col-md-6 col-lg-3">
              <div
                style={{
                  "border-radius": "8px",
                  color: "white",
                  position: "relative",
                  height: "clamp(140px, 20vw, 160px)",
                  display: "flex",
                  "-webkit-flex-direction": "column",
                  "-ms-flex-direction": "column",
                  "flex-direction": "column",
                  "-webkit-box-pack": "space-between",
                  "-webkit-justify-content": "space-between",
                  "-ms-flex-pack": "space-between",
                  "justify-content": "space-between",
                  overflow: "hidden",
                  "background-color": "rgb(3, 123, 252)",
                }}
              >
                <div style={{ padding: "20px" }}>
                  <div
                    style={{
                      "font-family": "Arial, san-serif",
                      "font-size": "clamp(24px, 4vw, 28px)",
                      margin: "8px 0px",
                      "line-height": "1",
                    }}
                  >
                    <span
                      style={{ "font-size": "0.4em", "margin-right": "4px" }}
                    >
                      Online User
                    </span>
                    {data?.onlineUser || 0}
                  </div>
                </div>
                <div
                  style={{
                    "font-size": "12px",
                    "font-weight": "600",
                    opacity: "0.8",
                    display: "flex",
                    "-webkit-align-items": "center",
                    "-webkit-box-align": "center",
                    "-ms-flex-align": "center",
                    "align-items": "center",
                    gap: "4px",
                    width: "100%",
                    padding: "10px",
                    background: "rgba(0, 0, 0, 0.15)",
                  }}
                >
                  Online User
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={32}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-user-check"
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    bottom: "50px",
                    right: "15px",
                    opacity: "0.4",
                    width: "64px",
                    height: "64px",
                  }}
                >
                  <path d="m16 11 2 2 4-4" />
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx={9} cy={7} r={4} />
                </svg>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div
                style={{
                  "border-radius": "8px",
                  color: "white",
                  position: "relative",
                  height: "clamp(140px, 20vw, 160px)",
                  display: "flex",
                  "-webkit-flex-direction": "column",
                  "-ms-flex-direction": "column",
                  "flex-direction": "column",
                  "-webkit-box-pack": "space-between",
                  "-webkit-justify-content": "space-between",
                  "-ms-flex-pack": "space-between",
                  "justify-content": "space-between",
                  overflow: "hidden",
                  "background-color": "rgb(16, 185, 129)",
                }}
              >
                <div style={{ padding: "20px" }}>
                  <div
                    style={{
                      "font-family": "Arial, san-serif",
                      "font-size": "clamp(24px, 4vw, 28px)",
                      margin: "8px 0px",
                      "line-height": "1",
                    }}
                  >
                    <span style={{ "font-size": "0.4em", margin: "0px 2px" }}>
                      All Exposure
                    </span>
                    {data?.totalExposer || 0.0}
                  </div>
                </div>
                <div
                  style={{
                    "font-size": "12px",
                    "font-weight": "600",
                    opacity: "0.8",
                    display: "flex",
                    "-webkit-align-items": "center",
                    "-webkit-box-align": "center",
                    "-ms-flex-align": "center",
                    "align-items": "center",
                    gap: "4px",
                    width: "100%",
                    padding: "10px",
                    background: "rgba(0, 0, 0, 0.15)",
                  }}
                >
                  All Exposure
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={32}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-trending-up"
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    bottom: "50px",
                    right: "15px",
                    opacity: "0.4",
                    width: "64px",
                    height: "64px",
                  }}
                >
                  <path d="M16 7h6v6" />
                  <path d="m22 7-8.5 8.5-5-5L2 17" />
                </svg>
              </div>
            </div>
          </div>{" "}
          <div className="bet_status mb-3" style={{ display: "flex" }}>
            <div className="bet-sec bet-period">
              <Form.Label className="mt-2 me-2">From</Form.Label>
              <Form.Group className="form-group">
                <Form.Control
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      fromPeriod: e.target.value,
                    })
                  }
                  max={new Date().toISOString().split("T")[0]}
                  value={filter.fromPeriod}
                  type="date"
                />
                <Form.Control
                  className="small_form_control"
                  type="text"
                  placeholder="00:00"
                  disabled
                />
              </Form.Group>
            </div>

            <div className="bet-sec bet-period">
              <Form.Label className="mt-2 me-2">To</Form.Label>
              <Form.Group className="form-group">
                <Form.Control
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      toPeriod: e.target.value,
                    })
                  }
                  min={
                    filter?.fromPeriod
                      ? new Date(filter?.fromPeriod).toISOString().split("T")[0]
                      : new Date()
                  }
                  disabled={filter.fromPeriod ? false : true}
                  max={new Date().toISOString().split("T")[0]}
                  value={filter.toPeriod}
                  type="date"
                />
                <Form.Control
                  className="small_form_control"
                  type="text"
                  placeholder="23:59"
                  disabled
                />
              </Form.Group>
            </div>
            <Button
              className="theme_light_btn theme_dark_btn"
              onClick={() => {
                getTopAmount();
                getData();
              }}
            >
              Search
            </Button>
          </div>
          <Row>
            <Col lg={2} sm={2} className="mb-2">
              <div
                style={{
                  background: "#ffcc2e",
                  border: "1px solid grey",
                  borderRadius: "10px",
                  padding: "10px",
                  textAlign: `center`,
                }}
              >
                <h3 style={{ fontWeight: 700 }}>
                  {data?.exchangeExposer || 0.0}
                </h3>
                <p style={{ fontSize: "16px", padding: "0", margin: "0" }}>
                  Exchange Exposure
                </p>
              </div>
            </Col>
            <Col lg={2} sm={2} className="mb-2">
              <div
                style={{
                  background: "#ffcc2e",
                  border: "1px solid grey",
                  borderRadius: "10px",
                  padding: "10px",
                  textAlign: `center`,
                }}
              >
                <h3 style={{ fontWeight: 700 }}>
                  {data?.casinoExposer || 0.0}
                </h3>
                <p style={{ fontSize: "16px", padding: "0", margin: "0" }}>
                  Casino Exposure
                </p>
              </div>
            </Col>
            {/* <Col lg={2} sm={2} className="mb-2">
              <div
                style={{
                  background: "#ffcc2e",
                  border: "1px solid grey",
                  borderRadius: "10px",
                  padding: "10px",
                  textAlign: `center`,
                }}
              >
                <h3 style={{ fontWeight: 700 }}>{data?.commission || 0.0}</h3>
                <p style={{ fontSize: "16px", padding: "0", margin: "0" }}>
                  Commission
                </p>
              </div>
            </Col> */}
            <Col lg={2} sm={2} className="mb-2">
              <div
                style={{
                  background: "#ffcc2e",
                  border: "1px solid grey",
                  borderRadius: "10px",
                  padding: "10px",
                  textAlign: `center`,
                }}
              >
                <h3 style={{ fontWeight: 700 }}>{data?.pl || 0.0}</h3>
                <p style={{ fontSize: "16px", padding: "0", margin: "0" }}>
                  Profit Loss
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={12} lg={12} className="mt-2">
              <section className="account-table aprofit-downline">
                <h2 className="common-heading">Today Profit/Loss </h2>
                <div className="responsive transaction-history">
                  <Table>
                    <thead>
                      <tr>
                        <th scope="col">UID</th>

                        <>
                          <th scope="col">Sports PL </th>
                          <th scope="col">AWC Casino P/L </th>
                          {/* <th scope="col">India Casino P/L </th>
                          <th scope="col">IQ Casino P/L </th> */}
                          <th scope="col">Comm.</th>
                          <th scope="col">Total P/L</th>
                        </>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {pldata && pldata?.length > 0 ? (
                          pldata?.map((item, index) => {
                            let totalpl =
                              item?.sportData?.amount +
                              item?.casinoData?.amount;

                            return item?.sportData?.amount === 0 &&
                              item?.casinoData?.amount == 0 ? (
                              ""
                            ) : (
                              <>
                                <tr key={index + 1}>
                                  <>
                                    <td className="text-start">
                                      {item?.userType == "user" ? (
                                        <></>
                                      ) : (
                                        <>
                                          {/* <Link
                                            to={`/AllAprofitByDownline/${item._id}/${item?.userType}`}
                                        
                                          > */}

                                          {item?.username || null}
                                          {/* </Link> */}
                                        </>
                                      )}
                                    </td>
                                    <td>
                                      {" "}
                                      {Math.sign(item?.sportData?.amount) !==
                                      -1 ? (
                                        <span className="text-danger">
                                          (
                                          {helpers.currencyFormat(
                                            "-" + item?.sportData?.amount,
                                          )}
                                          )
                                        </span>
                                      ) : (
                                        <span className="text-success">
                                          {helpers.currencyFormat(
                                            Math.abs(item?.sportData?.amount),
                                          )}
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      {" "}
                                      {Math.sign(item?.casinoData?.amount) !==
                                      -1 ? (
                                        <span className="text-danger">
                                          (
                                          {helpers.currencyFormat(
                                            "-" + item?.casinoData?.amount,
                                          )}
                                          )
                                        </span>
                                      ) : (
                                        <span className="text-success">
                                          {helpers.currencyFormat(
                                            Math.abs(item?.casinoData?.amount),
                                          )}
                                        </span>
                                      )}
                                    </td>
                                    {/* <td>
                                      {" "}
                                      {Math.sign(
                                        item?.auraCasinoData?.amount
                                      ) !== -1 ? (
                                        <span className="text-danger">
                                          (
                                          {helpers.currencyFormat(
                                            "-" + item?.auraCasinoData?.amount
                                          )}
                                          )
                                        </span>
                                      ) : (
                                        <span className="text-success">
                                          {helpers.currencyFormat(
                                            Math.abs(
                                              item?.auraCasinoData?.amount
                                            )
                                          )}
                                        </span>
                                      )}
                                    </td> */}
                                    {/* <td>
                                      {" "}
                                      {Math.sign(item?.iqCasinoData?.amount) !==
                                      -1 ? (
                                        <span className="text-danger">
                                          (
                                          {helpers.currencyFormat(
                                            "-" + item?.iqCasinoData?.amount
                                          )}
                                          )
                                        </span>
                                      ) : (
                                        <span className="text-success">
                                          {helpers.currencyFormat(
                                            Math.abs(item?.iqCasinoData?.amount)
                                          )}
                                        </span>
                                      )}
                                    </td> */}
                                    <td>
                                      {helpers.currencyFormat(
                                        item?.sportData?.commission,
                                      )}
                                    </td>
                                    <td>
                                      {Math.sign(totalpl) !== -1 ? (
                                        <span className="text-danger">
                                          (
                                          {helpers.currencyFormat(
                                            "-" + Math.abs(totalpl),
                                          )}
                                          )
                                        </span>
                                      ) : (
                                        <span className="text-success">
                                          {helpers.currencyFormat(
                                            Math.abs(totalpl),
                                          )}
                                        </span>
                                      )}
                                    </td>
                                  </>
                                </tr>
                              </>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={12}>
                              <span>You have no bets in this time period.</span>
                            </td>
                          </tr>
                        )}
                        {pldata && pldata?.length > 0 && (
                          <>
                            <tr>
                              <th scope="col">Total</th>

                              <th scope="col">
                                {Math.sign(obj?.totalSportsPL) !== -1 ? (
                                  <span className="text-danger">
                                    (
                                    {helpers.currencyFormat(
                                      "-" + Math.abs(obj?.totalSportsPL),
                                    )}
                                    )
                                  </span>
                                ) : (
                                  <span className="text-success">
                                    {helpers.currencyFormat(
                                      Math.abs(obj?.totalSportsPL),
                                    )}
                                  </span>
                                )}
                              </th>
                              <th scope="col">
                                {Math.sign(obj?.totalCasinoPL) !== -1 ? (
                                  <span className="text-danger">
                                    (
                                    {helpers.currencyFormat(
                                      "-" + Math.abs(obj?.totalCasinoPL),
                                    )}
                                    )
                                  </span>
                                ) : (
                                  <span className="text-success">
                                    {helpers.currencyFormat(
                                      Math.abs(obj?.totalCasinoPL),
                                    )}
                                  </span>
                                )}
                              </th>
                              {/* <th scope="col">
                                {Math.sign(obj?.totalauraCasinoDataPL) !==
                                -1 ? (
                                  <span className="text-danger">
                                    (
                                    {helpers.currencyFormat(
                                      "-" + Math.abs(obj?.totalauraCasinoDataPL)
                                    )}
                                    )
                                  </span>
                                ) : (
                                  <span className="text-success">
                                    {helpers.currencyFormat(
                                      Math.abs(obj?.totalauraCasinoDataPL)
                                    )}
                                  </span>
                                )}
                              </th>
                              <th scope="col">
                                {Math.sign(obj?.totaliqCasinoDataDataPL) !==
                                -1 ? (
                                  <span className="text-danger">
                                    (
                                    {helpers.currencyFormat(
                                      "-" +
                                        Math.abs(obj?.totaliqCasinoDataDataPL)
                                    )}
                                    )
                                  </span>
                                ) : (
                                  <span className="text-success">
                                    {helpers.currencyFormat(
                                      Math.abs(obj?.totaliqCasinoDataDataPL)
                                    )}
                                  </span>
                                )}
                              </th> */}
                              <th scope="col">
                                {helpers.currencyFormat(
                                  sumData?.sport?.commission,
                                )}
                              </th>
                              <th scope="col">
                                {Math.sign(
                                  obj?.totalCasinoPL + obj?.totalSportsPL,
                                ) !== -1 ? (
                                  <span className="text-danger">
                                    (
                                    {helpers.currencyFormat(
                                      Math.abs(
                                        obj?.totalCasinoPL + obj?.totalSportsPL,
                                      ),
                                    )}
                                    )
                                  </span>
                                ) : (
                                  <span className="text-success">
                                    {helpers.currencyFormat(
                                      Math.abs(
                                        obj?.totalCasinoPL + obj?.totalSportsPL,
                                      ),
                                    )}
                                  </span>
                                )}
                              </th>
                            </tr>
                          </>
                        )}
                      </>
                    </tbody>
                  </Table>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <div
              className="top_player-wrap mb-4 w-100"
              style={{ paddingTop: `15px` }}
            >
              {/* <h2 className="common-heading">Risk Management Summary</h2> */}
              <div className="match-sec-sroller">
                <ul className="p-0 mb-0">
                  <li
                    onClick={() => {
                      setHeaderTab("amount");
                    }}
                  >
                    <a
                      className={headerTab == "amount" ? "active" : ""}
                      style={{ cursor: "pointer" }}
                    >
                      Top 10 Matched Amount Player
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      setHeaderTab("exposure");
                    }}
                  >
                    <a
                      className={headerTab == "exposure" ? "active" : ""}
                      style={{ cursor: "pointer" }}
                    >
                      Top 10 Exposure Player
                    </a>
                  </li>
                </ul>

                <Row className="gx-0">
                  <Col md={6}>
                    <div className="account-table bg-white h-100">
                      <div className="responsive">
                        <Table>
                          <thead>
                            <tr>
                              <th>UID</th>

                              <th>Exposure</th>
                              <th>Matched Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(headerTab == "amount"
                              ? topData?.matched
                              : topData?.exposure
                            )?.length > 0 &&
                              (headerTab == "amount"
                                ? topData?.matched
                                : topData?.exposure
                              )
                                ?.slice(0, 5)
                                .map((res, index) => {
                                  return (
                                    <tr key={index + 1}>
                                      <td>
                                        <Link
                                          to={`/currentBets/${res._id}/${res.userType}`}
                                        >
                                          {index + 1}{" "}
                                          <a href="#">{res.username}</a>
                                        </Link>
                                      </td>

                                      <td>
                                        <strong className="text-danger">
                                          ({" "}
                                          {helpers.currencyFormat(res.exposure)}
                                          ){" "}
                                        </strong>
                                      </td>
                                      <td>
                                        {helpers.currencyFormat(
                                          res.totalAmount,
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                            {isEmpty(
                              headerTab == "amount"
                                ? topData?.matched
                                : topData?.exposure,
                            ) ? (
                              <tr>
                                <td colSpan={9}>No records found</td>
                              </tr>
                            ) : null}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>
                  {(headerTab == "amount"
                    ? topData?.matched
                    : topData?.exposure
                  )?.length > 6 && (
                    <Col md={6}>
                      <div className="account-table bg-white h-100 border_left">
                        <div className="responsive">
                          <Table>
                            <thead>
                              <tr>
                                <th>UID</th>

                                <th>Exposure</th>
                                <th>Matched Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(headerTab == "amount"
                                ? topData?.matched
                                : topData?.exposure
                              )?.length > 0 &&
                                (headerTab == "amount"
                                  ? topData?.matched
                                  : topData?.exposure
                                )
                                  ?.slice(5)
                                  ?.map((res, index) => {
                                    return (
                                      <tr key={index + 1}>
                                        <td>
                                          <Link
                                            to={`/currentBets/${res._id}/${res.userType}`}
                                          >
                                            {index + 6}{" "}
                                            <a href="#">{res.username}</a>
                                          </Link>
                                        </td>

                                        <td>
                                          <strong className="text-danger">
                                            (
                                            {helpers.currencyFormat(
                                              res.exposure,
                                            )}
                                            ){" "}
                                          </strong>
                                        </td>
                                        <td>
                                          {helpers.currencyFormat(
                                            res.totalAmount,
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              {isEmpty(
                                headerTab == "amount"
                                  ? topData?.matched
                                  : topData?.exposure,
                              ) ? (
                                <tr>
                                  <td colSpan={9}>No records found</td>
                                </tr>
                              ) : null}
                              {/* {topData?.matched?.length == 10 && (
                                              <tr>
                                                <Button
                                                  onClick={() => navigate("/matchedAll")}
                                                  className="green-btn mt-2 p-1"
                                                >
                                                  View All
                                                </Button>
                                              </tr>
                                            )} */}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </Row>{" "}
         <Row>

            <div
              className="top_player-wrap mb-4 w-100"
              style={{ paddingTop: `15px` }}
            >
              {/* <h2 className="common-heading">Risk Management Summary</h2> */}
              <div className="match-sec-sroller">
                <ul className="p-0 mb-0">
                  <li
                    onClick={() => {
                      setHeaderTab3("winning");
                    }}
                  >
                    <a
                      className={headerTab3 == "winning" ? "active" : ""}
                      style={{ cursor: "pointer" }}
                    >
                      Top 10 Winning Player
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      setHeaderTab3("lossing");
                    }}
                  >
                    <a
                      className={headerTab3 == "lossing" ? "active" : ""}
                      style={{ cursor: "pointer" }}
                    >
                      Top 10 Losing Player
                    </a>
                  </li>
                </ul>

                <Row className="gx-0">
                  <Col md={6}>
                    <div className="account-table bg-white h-100">
                      <div className="responsive">
                        <Table>
                          <thead>
                            <tr>
                              <th>Player</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(headerTab3 == "winning"
                              ? data?.winningUser
                              : data?.loosingUser
                            )?.length > 0 &&
                              (headerTab3 == "winning"
                                ? data?.winningUser
                                : data?.loosingUser
                              )
                                ?.slice(0, 5)
                                .map((res, index) => {
                                  return (
                                    <tr key={index + 1}>
                                      <td>
                                        <a href="#">{res.username}</a>
                                      </td>

                                      <td>
                                        <span
                                          style={{
                                            color:
                                              headerTab3 == "lossing"
                                                ? "red"
                                                : "green",
                                          }}
                                        >
                                          {helpers.currencyFormat(
                                            Math.abs(res.amount)
                                          )}{" "}
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                            {isEmpty(
                              headerTab3 == "winning"
                                ? data?.winningUser
                                : data?.loosingUser
                            ) ? (
                              <tr>
                                <td colSpan={9}>No records found</td>
                              </tr>
                            ) : null}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>
                  {(headerTab3 == "winning"
                    ? data?.winningUser
                      : data?.loosingUser
                  )?.length > 6 && (
                    <Col md={6}>
                      <div className="account-table bg-white h-100 border_left">
                        <div className="responsive">
                          <Table>
                            <thead>
                              <tr>
                               <th>Player</th>
                              <th>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(headerTab3 == "winning"
                              ? data?.winningUser
                              : data?.loosingUser
                            )?.length > 0 &&
                              (headerTab3 == "winning"
                                ? data?.winningUser
                                : data?.loosingUser
                              )
                                  ?.slice(5)
                                  ?.map((res, index) => {
                                    return (
                                      <tr key={index + 1}>
                                      <td>
                                        <a href="#">{res.username}</a>
                                      </td>

                                      <td>
                                        <span
                                          style={{
                                            color:
                                              headerTab3 == "lossing"
                                                ? "red"
                                                : "green",
                                          }}
                                        >
                                          {helpers.currencyFormat(
                                            Math.abs(res.amount)
                                          )}{" "}
                                        </span>
                                      </td>
                                    </tr>
                                    );
                                  })}
                            {isEmpty(
                              headerTab3 == "winning"
                                ? data?.winningUser
                                : data?.loosingUser
                            ) ? (
                                <tr>
                                  <td colSpan={9}>No records found</td>
                                </tr>
                              ) : null}
                              {/* {topData?.matched?.length == 10 && (
                                              <tr>
                                                <Button
                                                  onClick={() => navigate("/matchedAll")}
                                                  className="green-btn mt-2 p-1"
                                                >
                                                  View All
                                                </Button>
                                              </tr>
                                            )} */}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
              
            </div>
          </Row>
          {
            user?.userType=="sub_owner" || user?.userType=="super_admin"
          ?
          <Row>
            <div
              className="top_player-wrap mb-4 w-100"
              style={{ paddingTop: `15px` }}
            >
              {/* <h2 className="common-heading">Risk Management Summary</h2> */}
              <div className="match-sec-sroller">
                <ul className="p-0 mb-0">
                  {/* <li
                                  onClick={() => {
                                    setHeaderTab("amount");
                                  }}
                                >
                                  <a
                                    className={headerTab == "amount" ? "active" : ""}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Top 5 Matched Exchange
                                  </a>
                                </li> */}
                  <li
                    onClick={() => {
                      setHeaderTab2("suspect_users");
                    }}
                  >
                    <a
                      className={headerTab == "suspect_users" ? "active" : ""}
                      style={{ cursor: "pointer" }}
                    >
                      Top 10 Suspicious User
                    </a>
                  </li>
                  <li>
                    <a
                      className={headerTab == "suspect_users" ? "active" : ""}
                      style={{ cursor: "pointer" }}
                    >
                      Power By Betfair AI
                    </a>
                  </li>
                </ul>

                <Row className="gx-0">
                  <Col md={6}>
                    <div className="account-table bg-white h-100">
                      <div className="responsive">
                        <Table>
                          <thead>
                            <tr>
                              <th>User Name</th>
                              <th>Reason</th>
                              <th style={{ width: `35%`, textAlign: `center` }}>
                                Action{" "}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {(headerTab2 == "suspect_users"
                              ? topData?.matched
                              : topData?.exposure
                            )?.length > 0 &&
                              (headerTab2 == "suspect_users"
                                ? topData?.matched
                                : topData?.exposure
                              )
                                ?.slice(0, 5)
                                .map((res, index) => {
                                  return (
                                    <tr key={index + 1}>
                                      <td>
                                        <Link
                                          to={`/currentBets/${res._id}/${res.userType}`}
                                        >
                                          {index + 1}{" "}
                                          <a href="#">{res.username}</a>
                                        </Link>
                                      </td>
                                      <td></td>
                                      <td className="text-end">
                                        <Link
                                          to="#"
                                          className="green-btn cursor-pointer"
                                        >
                                          Mark Cheater
                                        </Link>

                                        <Link
                                          to="#"
                                          className="green-btn cursor-pointer"
                                        >
                                          Remove From List
                                        </Link>
                                      </td>
                                    </tr>
                                  );
                                })}
                            {isEmpty(
                              headerTab2 == "suspect_users"
                                ? topData?.matched
                                : topData?.exposure,
                            ) ? (
                              <tr>
                                <td colSpan={9}>No records found</td>
                              </tr>
                            ) : null}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>
                  {(headerTab2 == "suspect_users"
                    ? topData?.matched
                    : topData?.exposure
                  )?.length > 6 && (
                    <Col md={6}>
                      <div className="account-table bg-white h-100 border_left">
                        <div className="responsive">
                          <Table>
                            <thead>
                              <tr>
                                <th>User Name</th>
                                <th>Reason</th>
                                <th
                                  style={{ width: `35%`, textAlign: `center` }}
                                >
                                  Action{" "}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {(headerTab2 == "suspect_users"
                                ? topData?.matched
                                : topData?.exposure
                              )?.length > 0 &&
                                (headerTab2 == "suspect_users"
                                  ? topData?.matched
                                  : topData?.exposure
                                )
                                  ?.slice(5)
                                  ?.map((res, index) => {
                                    return (
                                      <tr key={index + 1}>
                                        <td>
                                          <Link
                                            to={`/currentBets/${res._id}/${res.userType}`}
                                          >
                                            {index + 6}{" "}
                                            <a href="#">{res.username}</a>
                                          </Link>
                                        </td>
                                        <td></td>

                                        <td className="text-end">
                                          <Link
                                            to="#"
                                            className="green-btn cursor-pointer"
                                          >
                                            Mark Cheater
                                          </Link>

                                          <Link
                                            to="#"
                                            className="green-btn cursor-pointer"
                                          >
                                            Remove From List
                                          </Link>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              {isEmpty(
                                headerTab2 == "suspect_users"
                                  ? topData?.matched
                                  : topData?.exposure,
                              ) ? (
                                <tr>
                                  <td colSpan={9}>No records found</td>
                                </tr>
                              ) : null}
                              {/* {topData?.matched?.length == 10 && (
                                              <tr>
                                                <Button
                                                  onClick={() => navigate("/matchedAll")}
                                                  className="green-btn mt-2 p-1"
                                                >
                                                  View All
                                                </Button>
                                              </tr>
                                            )} */}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </Row>:""}
        </Container>
      </section>
    </div>
  );
};

export default Dashboard2;
